export default __webpack_public_path__ + "87c1f44e9d68172262011ebd1b0d6b20.svg";